<template>
  <div id="app">
    <div style="z-index: 99996787899; display: none;">
      <p>The store data is</p>
      <p>{{storeData}}</p>
    </div>

    <modal v-if="false"/>

    <div v-if="isLoading" class="text-center mt-5">
      <i class="fa fa-spinner fa-spin fa-5x"></i>
    </div>
    <div v-else-if="finishedWithError" class="text-center mt-5">
      <strong class="text-danger d-block">
        An error occurred while initializing the app
      </strong>
      <b-button class="px-5 mt-4" size="lg" variant="primary" @click="init">
        <i class="fa fa-refresh mr-1"></i>
        Reload
      </b-button>
    </div>
    <router-view v-else/>
  </div>
</template>

<script>
  import '@coreui/icons/css/coreui-icons.min.css';
  import 'flag-icon-css/css/flag-icon.min.css';
  import 'bootstrap-vue/dist/bootstrap-vue.min.css';
  import 'vue-multiselect/dist/vue-multiselect.min.css';
  import Modal from './components/Modal';
  import {onEvent} from './tasks';
  import {initGeneral} from './store/general';
  import {initFiles} from './store/files';
  import {initSegments} from './store/segments';
  import {initLists} from './store/lists';
  import {CUSTOM_REPORTS_FETCH} from './store/customReports';

  export default {
    name: 'App',
    components: {Modal},

    sockets: {
      'connect'() {
        console.log('socket connected');
      },
      'task-progress'(data) {
        onEvent('progress', data);
      },
      'task-success'(data) {
        onEvent('success', data);
      },
      'task-failure'(data) {
        onEvent('failure', data);
      }
    },

    data() {
      return {
        isLoading: true,
        finishedWithError: false
      };
    },

    computed: {
      storeData() {
        return JSON.stringify(this.$store.state);
      }
    },

    created() {
      this.init();
    },

    methods: {
      init() {
        this.finishedWithError = false;
        this.isLoading = true;

        const actions = [
          initGeneral(),
          initFiles(),
          initSegments(),
          initLists(),
          {type: CUSTOM_REPORTS_FETCH}
        ];

        Promise.all(actions.map(action => this.$store.dispatch(action)))
          .catch(e => {
            console.log(e);
            this.finishedWithError = true;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  };
</script>

<style lang="scss">
  // CoreUI Icons Set
  // @import '~@coreui/icons/css/coreui-icons.min';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  // @import '~flag-icon-css/css/flag-icon.min';
  /* Import Bootstrap Vue Styles */
  // @import '~bootstrap-vue/dist/bootstrap-vue';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
